import React from "react";

import Button from "../ui/Button";
import { ONBOARDING_STEP_SLUGS } from "../../config/onboardingRoutes";

export function OnboardingShell({
  alert,
  alertTone = "default",
  loading,
  step,
  children,
  footerShowBack,
  onFooterBack,
  footerShowNext,
  footerRight,
}) {
  const stepCount = ONBOARDING_STEP_SLUGS.length;

  const alertClassName =
    alertTone === "danger"
      ? "mb-6 px-4 py-3 rounded border border-rose-500/30 bg-rose-500/10 font-mono text-xs text-theme-text"
      : "mb-6 px-4 py-3 rounded border border-theme-border bg-theme-panel font-mono text-xs text-theme-text";

  return (
    <div className="min-h-screen bg-theme-main text-theme-text px-6 py-10">
      <div className="max-w-3xl mx-auto">
        {alert ? (
          <div className={alertClassName} role="alert">
            {alert}
          </div>
        ) : null}

        {loading ? <div className="font-mono text-[12px] text-theme-muted">Loading...</div> : null}

        {children}

        <div className="mt-10 border-t border-theme-border pt-6 grid grid-cols-3 items-center gap-4">
          <div className="flex justify-start min-h-10 items-center">
            {footerShowBack ? (
              <Button variant="secondary" onClick={onFooterBack}>
                Back
              </Button>
            ) : null}
          </div>
          <div
            className="flex justify-center items-center gap-2"
            aria-label={`Onboarding progress, step ${step} of ${stepCount}`}
          >
            {ONBOARDING_STEP_SLUGS.map((_, i) => (
              <span
                key={i}
                className={`h-2 w-2 shrink-0 rounded-full transition-colors ${
                  i + 1 <= step ? "bg-theme-text opacity-90" : "bg-theme-dim opacity-45"
                }`}
              />
            ))}
          </div>
          <div className="flex justify-end min-h-10 items-center gap-2 flex-wrap">
            {footerShowNext ? footerRight : null}
          </div>
        </div>
      </div>
    </div>
  );
}
